// Web storage of SSO login tokens.
let ssoParentLoginToken = null;

export function getSSOParentLoginToken() {
    return ssoParentLoginToken;
}

export function setSSOParentLoginToken(parentLoginToken) {
    ssoParentLoginToken = parentLoginToken;
}
